// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__169t9","label":"Section_label__1y6b2","contentWrap":"Section_contentWrap__3Jh9x","footer":"Section_footer__2wh9M","footerInner":"Section_footerInner__27DJm"};